/**
 * Foundaiton.Facebook namespace.
 */
Foundation.Facebook = {};

// ---------------------------------------------------------------------

window["Foundation"]["Facebook"] = {};

// ---------------------------------------------------------------------

